import { Pipe, PipeTransform } from '@angular/core';
import { OrderableSpecialStepAlternative } from 'ngx-web-api';

@Pipe({
  name: 'sortByLineNumber',
})
export class SortByLineNumberPipe implements PipeTransform {
  transform(orderableSpecialStepAlternative: OrderableSpecialStepAlternative[]): OrderableSpecialStepAlternative[] {
    const allItems = [];
    orderableSpecialStepAlternative.forEach(alternative => {
      allItems.push(...alternative.items);
    });

    allItems.sort((a, b) => {
      if (this.checkZeroValue(a.tabPriority) === this.checkZeroValue(b.tabPriority)) {
        return a.label.localeCompare(b.label);
      }
      return this.checkZeroValue(a.tabPriority) > this.checkZeroValue(b.tabPriority) ? 1 : -1;
    });

    const copy = orderableSpecialStepAlternative[0].copy();
    copy.items = allItems;
    return [copy];
  }

  // zero check is needed as we want the 0 value to be sorted at the last eg. 1,3,5,0 and not 0, 1, 3, 5
  checkZeroValue(value: number) {
    return value === 0 ? Infinity : value;
  }
}
